export const checkEmptyObject = o =>
    Object.prototype.toString.call(o) === '[object Object]'
    && JSON.stringify(o) === '{}';


export const debounce = (func, wait) => {
    let timeout;
    return () => {
        const context = this;
        const args = arguments;
        const later = () => {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (!timeout) func.apply(context, args);
    };
};

const checkProductNameFormat = (productName) => {
    if (!PRODUCT_NAME_REG_EXP.test(productName)) {
        throw new Error('Product name format is not correct. Correct format example: NTIA.5.12');
    }
};

export const getShortName = (productName) => {
    checkProductNameFormat(productName);
    return productName.split('.')[0];
};
export const getDarwinColorByFullName = (fullName) => {
    if (!fullName) return '01';
    const color = parseInt(fullName.split(/\./g)[2], 10);
    return (color < 10 ? '0' : '').concat(color.toString());
}

export const isString = value => typeof value === 'string' || value instanceof String;
